export const budgetTypeToFriendlyNames = {
  insertions: "Listens",
  funds: "Dollars",
};
